export const ADD_CONTACT_TO_DELETE = "setEmailDataErrors";

export default {

};
